module.exports = __webpack_public_path__ + "static/media/brush.cec18e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brush.jpg
// module id = 82
// module chunks = 0